import { attach, createEvent, sample } from 'effector'

import { $navigate } from './navigate'

export const backOr = createEvent<string>()

export const backOrFx = attach({
  source: $navigate,
  effect: (navigate, fallback: string) => {
    if (window.history.length > 1) return navigate(-1)

    return navigate(fallback, { replace: true })
  },
})

sample({
  clock: backOr,
  target: backOrFx,
})
